import {Container, Grid, Paper, Snackbar, TableBody, TableHead} from "@mui/material";
import {
    StyledAlert, StyledButtonContainer,
    StyledButtonOrange,
    StyledTable, StyledTableBodyRow,
    StyledTableCell, StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../styles/MyStyles";
import React, {useEffect, useState} from "react";
import * as DataProvider from "../../logic/DataProvider";
import {GetLookupValueName} from "../../logic/LookupHelper";
import dayjs from "dayjs";
import {GetEnumValueName} from "../../logic/EnumHelper";
import * as TransferHelper from "../../logic/TrasferHelper";
import * as ConfirmationDownloader from "../../logic/ConfirmationDownloader";
import {useNavigate} from "react-router-dom";


const TransfersPage = () => {
    const navigate = useNavigate();
    const [transfers, setTransfers] = useState([]);
    const [wallets, setWallets] = useState([]);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [snackbar, setSnackbar] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: ''
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        try {
            let bundle = DataProvider.GetClientBundle();
            if (bundle.transfers) {
                let entities = bundle.transfers;
                setTransfers(JSON.parse(JSON.stringify(entities)));
            }
            if (bundle.bankAccounts) {
                let entities = bundle.bankAccounts;
                setBankAccounts(JSON.parse(JSON.stringify(entities)));
            }
            if (bundle.wallets) {
                let entities = bundle.wallets;
                setWallets(JSON.parse(JSON.stringify(entities)));
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const handleDepositRequestNew = () => {
        navigate(`request/deposit`);
    };

    const handleWithdrawalRequestNew = () => {
        navigate(`request/withdrawal`);
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}>
                <StyledAlert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                    {snackbar.message}
                </StyledAlert>
            </Snackbar>
            <StyledButtonContainer container>
                <Grid>
                    <StyledButtonOrange variant="contained" onClick={handleDepositRequestNew}>
                        Deposit
                    </StyledButtonOrange>
                </Grid>
                <Grid>
                    <StyledButtonOrange variant="contained" onClick={handleWithdrawalRequestNew}>
                        Withdrawal
                    </StyledButtonOrange>
                </Grid>
            </StyledButtonContainer>
            <StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={8}>Date</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={8}>Type</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={8}>From</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={8}>Amount From</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={8}>To</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={8}>Fee</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={8}>Fee Asset</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={8}></StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {transfers && transfers.map((transfer) => (
                            <StyledTableBodyRow key={transfer.id}>
                                <StyledTableCell>{dayjs(transfer.date).toString()}</StyledTableCell>
                                <StyledTableCell>{GetEnumValueName('transferType', transfer.type)}</StyledTableCell>
                                <StyledTableCell>{TransferHelper.GetTransferSide(wallets, bankAccounts, transfer.type, transfer.fromId)}</StyledTableCell>
                                <StyledTableCell>{transfer.amountFrom}</StyledTableCell>
                                <StyledTableCell>{TransferHelper.GetTransferSide(wallets, bankAccounts, transfer.type, transfer.toId)}</StyledTableCell>
                                <StyledTableCell>{transfer.fee}</StyledTableCell>
                                <StyledTableCell>{GetLookupValueName('asset', transfer.feeAssetId)}</StyledTableCell>
                                <StyledTableCell>
                                    <StyledButtonOrange
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            ConfirmationDownloader.GenerateTransferConfirmation(transfer.id, snackbar, setSnackbar);
                                        }}>
                                        Confirmation
                                    </StyledButtonOrange>
                                </StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>
        </Container>
    );
};
export default TransfersPage;